import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/Login.vue'
import Layout from '../views/layout/Index.vue'
import NProgress from '@/utils/nprogress';
Vue.use(VueRouter)
//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export const constantRoutes = [	
	{
		path: '/',
		name: 'main',
		component: Layout,
		meta: {
			isLogin:true
		},
		children: [	
			{
			  path:'/',
			  name:'Home',
			  component: () => import('@/views/index.vue'),
			  meta: {
			  	title: '桌面',
			  }
			},			
			{
				path: '/manage/selfinfo',
				component: () => import('@/views/manage/userinfo.vue'),
				name: 'selfinfo',
				meta: {
					title: '个人信息',
				}
			},
			{
				path: '/manage/DeptStatistic',
				component: () => import('@/views/manage/DeptStatistic.vue'),
				name: 'DeptStatistic',
				meta: {
					title: '部门统计',
				}
			},
			{
				path: '/manage/PersonalStatistic',
				component: () => import('@/views/manage/PersonalStatistic.vue'),
				name: 'PersonalStatistic',
				meta: {
					title: '个人统计',
				}
			}

		]
	},
	{
		path: '/login',
		name: 'login',
		component: Login,		
	},
	{
		path: '/login/wechat/callback',
		name: 'wechatCallback',
		component: () => import('@/views/login/WechatCallback.vue'),
		meta: {
			hidden: true
		}
	},	
	{
	    path: '/error-page/404',
	    component: () => import('@/views/error-page/404'),
	    hidden: true
	},
]
/*const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})*/
//任意路由：当路径出现错误的时候重定向404
export const anyRoutes ={ path: '*', redirect: '/error-page/404', hidden: true };
const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  //因为注册的路由是‘死的’，‘活的’路由如果根据不同用户（角色）可以展示不同菜单
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  // router.matcher是比较核心的一个属性。对外提供两个方法match(负责route匹配), addRoutes（动态添加路由）。
  // 对router.matcher属性做修改，即新的routes就会替换老的routes, 其实就是replaceRoutes()的含义（但是官方没有提供这个API）。
  router.matcher = newRouter.matcher // reset router
}
router.beforeEach((to, from , next) => {
  // 每次切换页⾯时，调⽤进度条
  NProgress.start();
  // 这个⼀定要加，没有next()页⾯不会跳转的。这部分还不清楚的去翻⼀下官⽹就明⽩了
  next();
});
router.afterEach(() => {  
  window.scrollTo(0,0);
  // 在即将进⼊新的页⾯组件前，关闭掉进度条
  NProgress.done()
})
export default router